export const pageDefaultState = {
    history: null,
    queryString: null,
    mainContainer: {
        topCmp: null,
    },
    quotePopup: {
        opened: false,
    },
    loadingOverlay: {
        show: false,
        message: null,
    },
    partnerIsLoad: false,
    appModal: {
        isOpen: false,
        type: null,
        showActionButton: true,
        actionType: null,
    },
};
